import { render, staticRenderFns } from "./ApproveRate.vue?vue&type=template&id=1b87a361&scoped=true"
import script from "./ApproveRate.vue?vue&type=script&lang=js"
export * from "./ApproveRate.vue?vue&type=script&lang=js"
import style0 from "./ApproveRate.vue?vue&type=style&index=0&id=1b87a361&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87a361",
  null
  
)

export default component.exports